const debug = (...args) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.error(...args); // eslint-disable-line
};

export default debug;
